import React, { useCallback, useRef, useState } from 'react';
import {
  FiMail,
  FiUser,
  FiLock,
  FiFileMinus,
  FiCalendar,
  FiPhone,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Loading } from '../../components/Loading';
import api from '../../services/api';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';
import Input from '../../components/Input';
import Button from '../../components/Button';
import ModalConexao from '../../components/ModalConexao';

import { Container, Content, AnimationContainer } from './styles';

interface SignUpFormData {
  nome: string;
  email: string;
  cpf: string;
  telefone: string;
  password: string;
  dataNascimento: string;
}

const SignUpSupervisor: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: SignUpFormData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          nome: Yup.string().required('Nome obrigatório !'),
          email: Yup.string()
            .required('E-mail obrigatório !')
            .email('Digite um email válido !'),
          cpf: Yup.string().required('CPF obrigatório !'),
          dataNascimento: Yup.string().required(
            'Data de Nascimento obrigatória !',
          ),
          telefone: Yup.string().required('Telefone obrigatório !'),
          password: Yup.string().min(6, 'No mínimo 6 dígitos !'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const { nome } = data;
        const { email } = data;
        const { cpf } = data;
        const { telefone } = data;
        const { dataNascimento } = data;
        const { password } = data;

        await api
          .post('/users', {
            nome,
            email,
            password,
            cpf,
            telefone,
            dataNascimento,
          })
          .then(() => {
            setLoading(false);
            addToast({
              type: 'success',
              title: 'Cadastro realizado com Sucesso!',
            });
            // console.log('Sucess!');
          })
          .catch(() => {
            setLoading(false);
            addToast({
              type: 'error',
              title: 'Erro ao cadastrar!',
              description: 'Tente Novamente!',
            });
          });
      } catch (err) {
        // console.log(err);
        if (err instanceof Yup.ValidationError) {
          setLoading(false);
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro no Cadastro',
          description:
            'Ocorreu um erro ao fazer o Cadastro, Por favor verifique os campos.',
        });
      } finally {
        // setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <>
      <ModalConexao />
      <Container>
        <Content>
          <h1>Cadastro</h1>
          <AnimationContainer>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <Input name="nome" icon={FiUser} placeholder="Nome Completo" />
              <Input name="email" icon={FiMail} placeholder="E-mail" />
              <Input
                name="cpf"
                icon={FiFileMinus}
                placeholder="CPF"
                mask="cpf"
              />
              <Input
                name="dataNascimento"
                icon={FiCalendar}
                placeholder="Data de Nascimento"
                mask="dateOfBirth"
              />
              <Input
                name="telefone"
                icon={FiPhone}
                placeholder="Telefone"
                mask="phone"
              />
              <Input
                name="password"
                icon={FiLock}
                type="password"
                placeholder="Senha"
              />

              <Button type="submit">Cadastrar</Button>
            </Form>
          </AnimationContainer>
        </Content>
        {loading && <Loading />}
      </Container>
    </>
  );
};

export default SignUpSupervisor;
